module.exports = "i.definido{color:dodgerblue}i.finalizadoCorrecto{color:green}i.problem{color:red}i.finalizado{color:goldenrod}\n"